import uuidv5 from 'uuid/v5';

// Mirror of est-back-end/helpers/contractTypeRemarkId.js.
//
// contract_types has no uuid `id` column (PK is the VARCHAR `type`), yet
// remarks.object_id is `uuid NOT NULL`. We derive a stable v5 UUID from the `type`
// string so the History/Remarks section can fetch (parent_object_id) and post
// (object_id) with a valid uuid that matches exactly what the back end writes for
// autogenerated create/update/delete remarks.
//
// The namespace + name scheme MUST stay identical to the back-end helper, or the
// front end and back end will compute different ids and history won't line up.
const NAMESPACE = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';

export default function contractTypeRemarkId(type) {
    return uuidv5(`contract_type:${type}`, NAMESPACE);
}
